/**
 * Rhenus RVK API
 * \"Rhenus RVK user and admin API Definitions\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Observable } from "rxjs";
import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";

import { JSONaddUserToLocation } from "../model/jSONaddUserToLocation";
import { JSONaddUserToLocationBNP } from "../model/jSONaddUserToLocationBNP";
import { JSONaddUserToLocationreturn } from "../model/jSONaddUserToLocationreturn";
import { JSONContactLocation } from "../model/jSONContactLocation";
import { JSONCustomerName } from "../model/jSONCustomerName";
import { JSONFElogging } from "../model/jSONFElogging";
import { JSONlocationId } from "../model/jSONlocationId";
import { JSONLocationName } from "../model/jSONLocationName";
import { JSONRhenusEmployee } from "../model/jSONRhenusEmployee";
import { JSONupdateUserData } from "../model/jSONupdateUserData";
import { JSONuserId } from "../model/jSONuserId";
import { Response } from "../model/response";

export abstract class RvkAdminServiceInterface {
  /**
   * Assign a new user to the location
   *
   * @param jsonuserlocation JSONaddUserToLocationBNP
   */

  public abstract addUserToLocation(
    jsonuserlocation: JSONaddUserToLocationBNP,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract addUserToLocation(
    jsonuserlocation: JSONaddUserToLocationBNP,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * Get a list of all locations that are assigned to me.
   *
   */

  public abstract allLocations(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONLocationName[]>;
  public abstract allLocations(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONLocationName[]>>;
  /**
   * Get a list of all users that are assigned to my location
   *
   */

  public abstract allUsersByMyLocation(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONuserId[]>;
  public abstract allUsersByMyLocation(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONuserId[]>>;
  /**
   * Get the contact information from the location
   *
   */

  public abstract contactLocations(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONContactLocation>;
  public abstract contactLocations(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONContactLocation>>;
  /**
   * Endpoint to log FE logs
   *
   * @param log log
   */

  public abstract felogging(
    log: JSONFElogging,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract felogging(
    log: JSONFElogging,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * Get a list of all Rhenus that are assigned to the given location
   *
   * @param locationName Name of the Location
   */

  public abstract getAllRhenusWorkerByLocation(
    locationName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONRhenusEmployee[]>;
  public abstract getAllRhenusWorkerByLocation(
    locationName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONRhenusEmployee[]>>;
  /**
   * Get all customer names by the locationname
   *
   * @param locationName Name of the location
   */

  public abstract getCustomerNamesBylocationName(
    locationName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONCustomerName[]>;
  public abstract getCustomerNamesBylocationName(
    locationName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONCustomerName[]>>;
  /**
   * Get the LocationId by customerId
   *
   * @param userId Id of the User
   */

  public abstract getLocationIdByCustomerId(
    userId: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONlocationId>;
  public abstract getLocationIdByCustomerId(
    userId: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONlocationId>>;
  /**
   * Get a list of all customers who assigned to my location
   *
   */

  public abstract locationAll(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONCustomerName[]>;
  public abstract locationAll(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONCustomerName[]>>;
  /**
   * update the Rhenus internal user Object
   *
   * @param userData JSONupdateUserData
   */

  public abstract updateUserData(
    userData: JSONupdateUserData,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract updateUserData(
    userData: JSONupdateUserData,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * Create a new User and assign him to the given Location
   *
   * @param jsonuserlocation JSONaddUserToLocation
   */

  public abstract userToLocation(
    jsonuserlocation: JSONaddUserToLocation,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONaddUserToLocationreturn>;
  public abstract userToLocation(
    jsonuserlocation: JSONaddUserToLocation,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONaddUserToLocationreturn>>;
}
